import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Table } from '../../../../common/table'
import { selectUserType } from '../../../../layout/store/slice'
import classes from '../../../index.module.scss'
import {
  selectLoadingPackageList,
  selectPackageListById,
  selectPackageListData,
  selectPackageListIds,
} from '../../store/slice'
import { getPricingPackages } from '../../store/thunk'
import { PACKAGE_LIST_TITLE } from '../popupUpgrade/constants'
import { ContentColumnCell } from './ContentColumnCell'
import { CustomThead } from './CustomThead'
import { FirstColumnCell } from './FirstColumnCell'

export const PackageList = () => {
  const dispatch = useDispatch()

  const ids = useSelector(selectPackageListIds)
  const isLoading = useSelector(selectLoadingPackageList)
  const dataTable = useSelector(selectPackageListData)
  const userType = useSelector(selectUserType)
  const locale = useSelector((state) => state.i18n.locale)

  const getSchema = () => {
    return PACKAGE_LIST_TITLE.map((item, index) => {
      const result = {
        title: <Translate value={item.title} />,
        colId: item.key,
      }
      const isCurrentUserTypeId = item.userTypeId === userType?.userTypeId
      if (index === 0) {
        return {
          ...result,
          renderCustom: (val, { rowId, rowIndex }) => {
            return FirstColumnCell(dataTable, rowId, val, rowIndex)
          },
        }
      }
      return {
        ...result,
        renderCustom: (val, { rowId, rowIndex, colId }) => {
          return ContentColumnCell(
            dataTable,
            rowId,
            colId,
            val,
            locale,
            rowIndex,
            isCurrentUserTypeId,
          )
        },
      }
    })
  }

  useEffect(() => {
    dispatch(getPricingPackages({ userType: userType?.userTypeId }))
  }, [locale])

  return (
    <div className="flexColumn h100">
      <Element
        className={[classes.viewDetailContent, 'fw500 textUppercase'].join(' ')}
        style={{ color: '#0553A5', fontSize: 24 }}
      >
        <Translate value="userManagement.packageList.TITLE" />
      </Element>
      <div className={[classes.viewDetailContent, ''].join(' ')}>
        <Table
          ids={ids}
          getDataFromRedux={selectPackageListById}
          schema={getSchema()}
          isLoading={isLoading}
          renderTHead={() => <CustomThead userType={userType} />}
          autoHeightMax={1000}
          isDisplayScroll={false}
        />
      </div>
    </div>
  )
}
